import React from 'react';

import { DemmiFS } from '@subhanhabib/demmilib';

interface Props {
  CSSBlock: string;
  productIDs: string[];
  refundRequest: DemmiFS.RefundRequest;
}

const OrderItemTabRefundCost: React.FC<Props> = ({
  CSSBlock,
  productIDs,
  refundRequest,
}) => {
  return (
    <div className={`${CSSBlock}__costing`}>
      <div className={`${CSSBlock}__key-val`}>
        <div className={`${CSSBlock}__key`}>
          {refundRequest.type === DemmiFS.RefundHelper.RefundType.PARTIAL_VENDOR
            ? `${productIDs.length} product${productIDs.length > 1 ? 's' : ''}`
            : 'All products'}{' '}
          included
        </div>
        <div className={`${CSSBlock}__value`}>
          {DemmiFS.CurrencyHelper.getCurrencySymbolFromCurrencyCode(
            refundRequest.costEstimate.currencyCode
          )}
          {Number(refundRequest.costEstimate.productsCost).toFixed(2)}
        </div>
      </div>
      {!!refundRequest.costEstimate.couponDeduction && (
        <div className={`${CSSBlock}__key-val`}>
          <div className={`${CSSBlock}__key`}>Coupon deductions</div>
          <div className={`${CSSBlock}__value`}>
            {DemmiFS.CurrencyHelper.getCurrencySymbolFromCurrencyCode(
              refundRequest.costEstimate.currencyCode
            )}
            {Number(refundRequest.costEstimate.couponDeduction).toFixed(2)}
          </div>
        </div>
      )}
      <div className={`${CSSBlock}__key-val`}>
        <div className={`${CSSBlock}__key`}>Total refund value</div>
        <div className={`${CSSBlock}__value`}>
          {DemmiFS.CurrencyHelper.getCurrencySymbolFromCurrencyCode(
            refundRequest.costEstimate.currencyCode
          )}
          {Number(refundRequest.costEstimate.totalRefund).toFixed(2)}
        </div>
      </div>
    </div>
  );
};

export default OrderItemTabRefundCost;
